module.exports = Promise.all([__parcel__import__("lfHGD"), __parcel__import__("gbTxU")]).then(() => parcelRequire('bRjqU'));